import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const featuredArticles = articles.slice(0, 3);

const articleImages: Record<string, string> = {
  'article-1': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20editorial%20photography%20scene%20with%20warm%20ambient%20lighting%20and%20soft%20shadows%2C%20clean%20composition%2C%20professional%20aesthetic%2C%20neutral%20background%20with%20subtle%20texture&width=600&height=400&seq=article-card-01&orientation=landscape',
  'article-2': 'https://readdy.ai/api/search-image?query=Elegant%20modern%20workspace%20with%20natural%20light%20streaming%20through%20large%20windows%2C%20minimal%20design%2C%20warm%20wood%20tones%2C%20clean%20and%20professional%20atmosphere&width=600&height=400&seq=article-card-02&orientation=landscape',
  'article-3': 'https://readdy.ai/api/search-image?query=Professional%20customer%20service%20headset%20on%20clean%20desk%20with%20soft%20lighting%2C%20modern%20office%20environment%2C%20warm%20and%20inviting%20atmosphere%2C%20corporate%20professional%20feel&width=600&height=400&seq=article-card-03&orientation=landscape',
};

export default function NewsSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10 md:mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              {t('news.title')}
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              {t('news.subtitle')}
            </p>
          </div>
          <Link
            to="/article/article-1"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('news.view_all')}
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={articleImages[article.id]}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 mb-2.5">
                  <span className="text-xs font-medium text-accent-700 bg-accent-100 px-2.5 py-0.5 rounded-full">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.publishDate}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.summary}
                </p>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">
                    <i className="ri-time-line mr-1" />
                    {article.readTime}
                  </span>
                  <span className="text-xs font-medium text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    {t('news.read_more')} <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}